import React from "react"
import PropTypes from "prop-types"
import Footer from "../LayoutFooter"
import Header from "../LayoutHeader"
import { withStyles } from "@material-ui/core/styles"

const styles = (theme) => ({
  layoutRoot: {
    display: "flex",
    flexDirection: "column",
    minHeight: "calc(100vh - 40px)",
  },
  flexForLayout: {
    display: "flex",
    flexDirection: "column",
    flexGrow: "1",
    flexShrink: "0",
    flexBasis: "auto",
    justifyContent: "stretch",
    alignItems: "flex-start",

    flex: "1 0 auto",
    marginTop: 60,

    [theme.breakpoints.between("sm", "md")]: {
      marginTop: 50,
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: 40,
    },
  },
})

class Layout extends React.Component {
  render() {
    const { children, location, classes, layoutHasSidebar } = this.props

    return (
      <div className={classes.layoutRoot}>
        <Header location={location} />
        <div className={classes.flexForLayout}>{children}</div>
        <Footer layoutHasSidebar={layoutHasSidebar} />
      </div>
    )
  }
}

Layout.defaultProps = {
  layoutHasSidebar: false,
}

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  location: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Layout)
